import script from "./FileManagerList.vue?vue&type=script&setup=true&lang=js"
export * from "./FileManagerList.vue?vue&type=script&setup=true&lang=js"

import "./FileManagerList.vue?vue&type=style&index=0&id=48e7179e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48e7179e"]])

export default __exports__